<template>
    <div class="input-container mt-3">
        <div class="row">
            <div class="col-md-5">
                <div class="form-group">
                    <label for="personId" class="form-label">Enter Entity Key</label>
                    <input id="personId" v-model="personId" type="text" class="form-control"
                        :class="{ 'is-invalid': !isValidFormat && personId }" placeholder="prsn~domain~uuid"
                        @keyup.enter="handleEnter">
                    <div class="invalid-feedback position-absolute" v-if="!isValidFormat && personId">
                        Invalid format. Expected format: prsn~domain~uuid
                        (e.g., prsn~c900~7702f98b-a8d9-11ef-9451-0242ac110003)
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label for="nodeLevel" class="form-label">Depth</label>
                    <input id="nodeLevel" v-model.number="nodeLevel" type="number" class="form-control" min="1"
                        placeholder="Enter Level (1-3)">
                </div>
            </div>

            <div class="col-md-2 align-self-center" v-if="personId !== ''">
                <button class="btn btn-primary w-100" @click="updateGraph" :disabled="!isValidFormat || loading">
                    <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <template v-else>
                        <i class="bi bi-search me-2"></i>
                        Update
                    </template>
                </button>
            </div>
        </div>
    </div>

    <D3ForceGraph :data="graphData" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import D3ForceGraph from './D3ForceGraph.vue'

export default {
    components: { D3ForceGraph },
    data() {
        return {
            personId: '',
            nodeLevel: 1,
            loading: false,
            graphData: null
        }
    },
    computed: {
        ...mapGetters('idr', ['getNetworkData']),
        networkData() {
            return this.getNetworkData;
        },
        isValidFormat() {
            const uuidPattern = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
            const pattern = new RegExp(`^prsn~[a-z0-9]+~${uuidPattern}$`, 'i');
            return this.personId ? pattern.test(this.personId) : true;
        }
    },
    methods: {
        ...mapActions({
            fetchAndConvertNetworkData: "idr/fetchAndConvertNetworkData",
        }),

        handleEnter() {
            if (this.isValidFormat && this.personId) {
                this.updateGraph();
            }
        },

        async updateGraph() {
            this.loading = true;
            try {
                await this.fetchAndConvertNetworkData({ personId: this.personId, maxLevel: this.nodeLevel });
                const data = this.networkData;
                if (!data || !data.nodes || !data.edges) {
                    console.error('Invalid network data:', data);
                    return;
                }

                const graph = { nodes: [], edges: [] };
                data.nodes.forEach(node => {
                    graph.nodes.push({ id: node.id, type: node.type, domain: node.domain, key: node.key });
                });
                data.edges.forEach(edge => {
                    graph.edges.push({ source: edge.from, target: edge.to });
                });
                this.graphData = graph;
            } catch (error) {
                console.error('Search failed:', error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>